import { render } from "./RecordedClassesPage.vue?vue&type=template&id=43afd7e6&scoped=true"
import script from "./RecordedClassesPage.vue?vue&type=script&lang=js"
export * from "./RecordedClassesPage.vue?vue&type=script&lang=js"

import "./RecordedClassesPage.vue?vue&type=style&index=0&id=43afd7e6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43afd7e6"]])

export default __exports__